import config from '@epi-config';

export const deductionReportsApiUrl = `${config.apiHost}/api/deduction-reports`;
export const incomeRegisterReportsApiUrl = `${config.apiHost}/api/income-register-reports`;
